import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IdentitableButtonEnum } from '../desktop/subscription-table-desktop.component';
import { PlanFeatureService } from 'src/app/services/common/plan-feature.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';
import { ProductType } from 'src/app/interfaces/user';

@Component({
  selector: 'app-subscription-table-mobile',
  templateUrl: './subscription-table-mobile.component.html',
  styleUrls: ['./subscription-table-mobile.component.scss']
})
export class SubscriptionTableMobileComponent {
  @Input() identibasePlusButtonLabel: string;
  @Input() identialertButtonLabel: string;

  @Input() basicPlusHighlighted: boolean;
  @Input() alertHighlighted: boolean;
  @Input() findHighlighted: boolean;
  @Input() buyButtonVisible: boolean;
  @Input() buyButtonDisabled: boolean;

  @Output() identitableButtonClicked: EventEmitter<string> = new EventEmitter();

  public plan1Name = this.configService.getTextFromKey('1-plan-name');
  public plan1YearlyPrice = this.configService.getTextFromKey('1-plan-yearly-price');
  public plan2Name = this.configService.getTextFromKey('2-plan-name');
  public plan2YearlyPrice = this.configService.getTextFromKey('2-plan-yearly-price');
  public plan2MonthlyPrice = this.configService.getTextFromKey('2-plan-monthly-price');
  public isBrandPetlog: boolean;
  public plan2DailyPrice: string;
  public brandName: string;
  public plan1DailyPrice: string;
  
  constructor(
    public planFeatureService: PlanFeatureService,
    private configService: ConfigService,
    private paymentConfigService: PaymentConfigService,
  ) {
    this.isBrandPetlog = this.configService.isPetlogBrand();
    this.plan2DailyPrice = this.configService.getTextFromKey('2-plan-daily-price');
    this.brandName = this.configService.getTextFromKey('brand-name');
    this.plan1DailyPrice = this.configService.getTextFromKey('1-plan-daily-price');

    this.plan1YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.BasicPlus) ?? this.plan1YearlyPrice;
    this.plan2YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Premium) ?? this.plan2YearlyPrice;
    this.plan2MonthlyPrice = this.paymentConfigService.getMonthlyDisplayPrice(
      ProductType.Premium,
      this.plan2MonthlyPrice
    );
  }

  public IdentitableButtonEnum = IdentitableButtonEnum;
  
  getFeaturesFor(plan: string): any[] {
    return this.planFeatureService.getFeaturesFor(plan);
  }

  public onIdentitableButtonClicked(buttonClicked: string) {
    this.identitableButtonClicked.emit(buttonClicked);
  }

}
